var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUzFlag = function SvgUzFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uzFlag_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uzFlag_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3 5.76c0-2.016 0-3.024.392-3.794A3.6 3.6 0 0 1-1.034.392C-.264 0 .744 0 2.76 0h12.48c2.016 0 3.024 0 3.794.392a3.6 3.6 0 0 1 1.574 1.574C21 2.736 21 3.744 21 5.76v6.48c0 2.016 0 3.024-.392 3.794a3.6 3.6 0 0 1-1.574 1.574c-.77.392-1.778.392-3.794.392H2.76c-2.016 0-3.024 0-3.794-.392a3.6 3.6 0 0 1-1.574-1.574C-3 15.264-3 14.256-3 12.24V5.76Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#uzFlag_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 12h24v6H-3v-6Z",
    fill: "#00B731"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3 0h24v7.5H-3V0Z",
    fill: "#03BCDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 7.125h-.375v5.25h24.75v-5.25H-3Z",
    fill: "#fff",
    stroke: "#C51918",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.906 2.255-.505.28.145-.57-.484-.419h.632l.211-.54.249.54h.538l-.423.419.204.57-.567-.28ZM5.2 3.973l.505-.28.566.28-.204-.57.424-.42h-.539l-.248-.539-.212.54H4.86l.484.419-.144.57ZM3.32 5.22l-.505.28.145-.57-.484-.419h.632l.211-.54.249.54h.538l-.423.419.204.57-.567-.28Zm2.384 0L5.2 5.5l.144-.57-.484-.419h.632l.212-.54.248.54h.539l-.424.419.204.57-.566-.28Zm2.235 0-.505.28.144-.57-.483-.419h.631l.212-.54.248.54h.539l-.423.419.203.57-.566-.28Zm-.505-1.248.505-.28.566.28-.203-.57.423-.42h-.539l-.248-.539-.212.54h-.631l.483.419-.144.57ZM9.685 5.5l.504-.28.566.28-.203-.57.423-.419h-.538l-.249-.54-.211.54h-.632l.484.419-.145.57Zm.504-1.809-.505.28.145-.57-.484-.418h.632l.211-.54.249.54h.538l-.423.419.204.57-.567-.28Zm-.538-1.157.504-.28.567.28-.204-.57.423-.419h-.538l-.248-.54-.212.54H9.31l.484.419-.144.57Zm2.81 2.686-.504.28.144-.57-.483-.419h.631l.212-.54.248.54h.539l-.423.419.203.57-.566-.28Zm-.504-1.248.505-.28.566.28-.203-.57.423-.42h-.539l-.248-.539-.212.54h-.631l.483.419-.144.57Zm.471-1.718-.505.28.145-.57-.484-.419h.632l.211-.54.249.54h.538l-.423.419.204.57-.567-.28ZM1.414 6.18S-.398 5.69-.364 3.871C-.33 2.054 1.5 1.581 1.5 1.581c-.748-.282-2.959.098-3 2.272C-1.54 6.027.718 6.456 1.415 6.18Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4.6H.6a3 3 0 0 0-3 3v10.8a3 3 0 0 0 3 3h16.8a3 3 0 0 0 3-3V3.6a3 3 0 0 0-3-3ZM.6 0A3.6 3.6 0 0 0-3 3.6v10.8A3.6 3.6 0 0 0 .6 18h16.8a3.6 3.6 0 0 0 3.6-3.6V3.6A3.6 3.6 0 0 0 17.4 0H.6Z",
    fill: "#000",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uzFlag_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#fff"
  })))));
};
export default SvgUzFlag;